import { createMachine, assign } from 'xstate';

import { Context, Events } from './types';

const initialContext: Context = {
  createPaymentProfile: {
    subscriptionId: null,
    catalogId: null,
    paymentMethod: null,
    activePaymentProfileId: null,
  },
  deletePaymentProfile: {
    subscriptionId: null,
    catalogId: null,
    paymentProfileId: null,
  },
  previewPaymentProfile: {
    subscriptionId: null,
    catalogId: null,
    paymentProfileId: null,
  },
  changePaymentProfile: {
    subscriptionId: null,
    catalogId: null,
    paymentProfileId: null,
  },
  componentsAllocation: {
    subscriptionId: null,
    catalogId: null,
  },
  resumeSubscription: {
    subscriptionId: null,
    catalogId: null,
  },
  pauseSubscription: {
    subscriptionId: null,
    catalogId: null,
  },
  cancelSubscription: {
    subscriptionId: null,
    catalogId: null,
  },
  undoCancelation: {
    subscriptionId: null,
    catalogId: null,
  },
  reactivateSubscription: {
    subscriptionId: null,
    catalogId: null,
  },
  changeSubscriptionPlan: {
    subscriptionId: null,
    catalogId: null,
  },
  threeDSecure: {
    subscriptionId: null,
    threeDsActionLink: null,
    catalogId: null,
    onSuccess: null,
  },
  addCoupon: {
    subscriptionId: null,
    catalogId: null,
    subscriptionDetailsService: null,
    currency: null,
  },
};

export const modals = createMachine<Context, Events>({
  id: 'modals',
  predictableActionArguments: true,
  initial: 'idle',
  context: initialContext,
  on: {
    CLOSE_MODAL: {
      target: 'idle',
      actions: [
        assign(() => ({
          ...initialContext,
        })),
      ],
    },
  },
  states: {
    idle: {
      on: {
        SHOW_CREATE_PAYMENT_PROFILE: {
          target: 'createPaymentProfile',
          actions: [
            assign(
              (
                _ctx,
                {
                  catalogId,
                  subscriptionId,
                  paymentMethod,
                  activePaymentProfileId,
                }
              ) => ({
                createPaymentProfile: {
                  catalogId,
                  subscriptionId,
                  paymentMethod,
                  activePaymentProfileId,
                },
              })
            ),
          ],
        },
        SHOW_ADDONS_CONFIGURATION: {
          target: 'addonsConfiguration',
          actions: [
            assign((ctx, { catalogId, subscriptionId }) => ({
              componentsAllocation: {
                ...ctx.componentsAllocation,
                catalogId,
                subscriptionId,
              },
            })),
          ],
        },
        SHOW_RESUME_SUBSCRIPTION: {
          target: 'resumeSubscription',
          actions: [
            assign((_ctx, { subscriptionId, catalogId }) => ({
              resumeSubscription: {
                subscriptionId,
                catalogId,
              },
            })),
          ],
        },
        SHOW_PAUSE_SUBSCRIPTION: {
          target: 'pauseSubscription',
          actions: [
            assign((_ctx, { catalogId, subscriptionId }) => ({
              pauseSubscription: {
                catalogId,
                subscriptionId,
              },
            })),
          ],
        },
        SHOW_CANCEL_SUBSCRIPTION: {
          target: 'cancelSubscription',
          actions: [
            assign((_ctx, { catalogId, subscriptionId }) => ({
              cancelSubscription: {
                catalogId,
                subscriptionId,
              },
            })),
          ],
        },
        SHOW_DELETE_PAYMENT_PROFILE: {
          target: 'deletePaymentProfile',
          actions: [
            assign((_ctx, { catalogId, subscriptionId, paymentProfileId }) => ({
              deletePaymentProfile: {
                catalogId,
                subscriptionId,
                paymentProfileId,
              },
            })),
          ],
        },
        SHOW_CHANGE_PAYMENT_PROFILE: {
          target: 'changePaymentProfile',
          actions: [
            assign((_ctx, { catalogId, subscriptionId, paymentProfileId }) => ({
              changePaymentProfile: {
                catalogId,
                subscriptionId,
                paymentProfileId,
              },
            })),
          ],
        },
        SHOW_PREVIEW_PAYMENT_PROFILE: {
          target: 'previewPaymentProfile',
          actions: [
            assign((_ctx, { catalogId, subscriptionId, paymentProfileId }) => ({
              previewPaymentProfile: {
                catalogId,
                subscriptionId,
                paymentProfileId,
              },
            })),
          ],
        },
        SHOW_UNDO_CANCELATION: {
          target: 'undoCancelation',
          actions: [
            assign((_ctx, { catalogId, subscriptionId }) => ({
              undoCancelation: {
                catalogId,
                subscriptionId,
              },
            })),
          ],
        },
        SHOW_REACTIVATE_SUBSCRIPTION: {
          target: 'reactivateSubscription',
          actions: [
            assign((_ctx, { catalogId, subscriptionId }) => ({
              reactivateSubscription: {
                catalogId,
                subscriptionId,
              },
            })),
          ],
        },
        SHOW_SUBSCRIPTION_PLAN_CHANGE: {
          target: 'changeSubscriptionPlan',
          actions: [
            assign((_ctx, { catalogId, subscriptionId }) => ({
              changeSubscriptionPlan: {
                catalogId,
                subscriptionId,
              },
            })),
          ],
        },
        SHOW_THREE_D_SECURE: {
          target: 'threeDSecure',
          actions: [
            assign(
              (
                _ctx,
                { subscriptionId, threeDsActionLink, catalogId, onSuccess }
              ) => ({
                threeDSecure: {
                  subscriptionId,
                  threeDsActionLink,
                  catalogId,
                  onSuccess,
                },
              })
            ),
          ],
        },
        SHOW_ADD_COUPON: {
          target: 'addCoupon',
          actions: [
            assign(
              (
                _ctx,
                {
                  subscriptionId,
                  catalogId,
                  subscriptionDetailsService,
                  currency,
                }
              ) => ({
                addCoupon: {
                  subscriptionId,
                  catalogId,
                  subscriptionDetailsService,
                  currency,
                },
              })
            ),
          ],
        },
      },
    },
    addCoupon: {},
    createPaymentProfile: {},
    previewPaymentProfile: {},
    changePaymentProfile: {},
    deletePaymentProfile: {},
    reactivateSubscription: {},
    paymentProfile: {},
    addonsConfiguration: {},
    pauseSubscription: {},
    resumeSubscription: {},
    cancelSubscription: {},
    undoCancelation: {},
    changeSubscriptionPlan: {},
    threeDSecure: {},
  },
});
